export function sessionStorageGetItem(key: string) {
  try {
    return JSON.parse(window.sessionStorage.getItem(key) || '')
  } catch (e) {
    return null
  }
}

export function sessionStorageSetItem(key: string, value: string) {
  try {
    return window.sessionStorage.setItem(key, JSON.stringify(value))
  } catch (e) {
    return
  }
}
